module.exports = __webpack_public_path__ + "static/fabricio-06cc389e6cd46aa2dfefcf3e880c9a11.jpg";